import { FC } from 'react';
import { IconPath, IconSVG, IconSVGComponentProps } from '../IconComponent';

export const GoalDebt: FC<IconSVGComponentProps> = ({
    pathProps,
    ...props
}) => {
    return (
        // Override viewBox & strokeWidth, since this is a solid icon
        <IconSVG viewBox="0 0 20 20" strokeWidth={0} {...props}>
            <IconPath
                fill="currentColor"
                fillRule="evenodd"
                d="M4 5a2 2 0 0 0-2 2v.526h16V7a2 2 0 0 0-2-2H4Zm14 4.21H2v3.895a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.211Z"
                clipRule="evenodd"
                {...pathProps}
            />
        </IconSVG>
    );
};
